import { styled } from "styled-components";

export const InstructorDetailWrapper = styled.div`
  padding: 60px 0;
  @media all and (max-width: 768px) {
    padding: 8.889vw 0;
  }
`;

export const InstructorDetailWrap = styled.div`
  display: flex;
  gap: 50px;
  .img-area {
    max-width: 580px;
    img {
      width: 100%;
    }
  }
  .text-area {
    flex: 1;

    .title-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      margin-bottom: 32px;
      h6 {
        font-weight: bold;
        font-size: 56px;
        line-height: 1.2;
        color: #242424;
      }
      > a {
        width: 64px;
        height: 64px;
        background-color: #efefef;
        border-radius: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 34px;
          height: 34px;
        }
      }
    }

    .class-wrap {
      padding-top: 16px;
      border-top: 1px solid #171717;
      margin-bottom: 52px;
      > dl {
        padding: 0 12px;
        display: flex;
        align-items: flex-start;
        margin-bottom: 32px;
        dt {
          margin-right: 32px;
          font-weight: 700;
          color: #171717;
          font-size: 20px;
        }
        dd {
          color: #6f6f6f;
          font-size: 16px;
          line-height: 1.3;

          p {
            &:not(:last-child) {
              margin-bottom: 4px;
            }
            display: flex;
            align-items: center;
            span {
              &:first-child {
                display: block;
                min-width: 90px;
              }
            }
          }
        }
      }
      > a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 68px;
        font-weight: bold;
        background-color: #171717;
        border-radius: 8px;
        font-size: 20px;
        line-height: 1.4;
        color: #fbfbfb;
      }
    }

    .career-wrap {
      padding-top: 16px;
      border-top: 1px solid #171717;
      margin-bottom: 52px;
      > dl {
        padding: 0 12px;
        display: flex;
        align-items: flex-start;
        margin-bottom: 32px;
        dt {
          margin-right: 32px;
          font-weight: 700;
          color: #171717;
          font-size: 20px;
        }
        dd {
          color: #6f6f6f;
          font-size: 16px;
          line-height: 1.3;

          p {
            &:not(:last-child) {
              margin-bottom: 4px;
            }
          }
        }
      }
    }
  }
  @media all and (max-width: 1200px) {
    gap: 30px;
    .img-area {
      max-width: 33.333vw;
    }
  }
  @media all and (max-width: 900px) {
    .text-area {
      .title-wrap {
        margin-bottom: 24px;
        h6 {
          font-size: 42px;
        }
        > a {
          width: 52px;
          height: 52px;
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
      .class-wrap {
        > dl {
          flex-direction: column;
          gap: 16px;
        }
      }
      .career-wrap {
        > dl {
          flex-direction: column;
          gap: 16px;
        }
      }
    }
  }
  @media all and (max-width: 640px) {
    flex-direction: column;
    gap: 6.25vw;
    .img-area {
      max-width: 100%;
    }
    .text-area {
      .title-wrap {
        margin-bottom: 3.75vw;
        h6 {
          font-size: 8.125vw;
        }
        > a {
          width: 11.25vw;
          height: 11.25vw;
          border-radius: 5.625vw;

          img {
            width: 6.563vw;
            height: 6.563vw;
          }
        }
      }

      .class-wrap {
        padding-top: 3.438vw;
        margin-bottom: 9.375vw;
        > dl {
          padding: 0 2.813vw;
          margin-bottom: 6.25vw;
          dt {
            margin-right: 6.25vw;
            font-size: 4.688vw;
          }
          dd {
            font-size: 4.063vw;

            p {
              &:not(:last-child) {
                margin-bottom: 1.25vw;
              }
              span {
                &:first-child {
                  min-width: 23.438vw;
                }
              }
            }
          }
        }
        > a {
          height: 12.188vw;
          border-radius: 1.563vw;
          font-size: 4.688vw;
        }
      }

      .career-wrap {
        padding-top: 3.438vw;
        margin-bottom: 9.375vw;
        > dl {
          padding: 0 2.813vw;
          margin-bottom: 6.25vw;
          dt {
            margin-right: 6.25vw;
            font-size: 4.688vw;
          }
          dd {
            font-size: 4.063vw;

            p {
              &:not(:last-child) {
                margin-bottom: 1.25vw;
              }
            }
          }
        }
      }
    }
  }
`;
